
































































































































































































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import { BvTableFieldArray, BvTableCtxObject } from "bootstrap-vue";
import {
	db,
	auth,
	busy,
	VIPUser,
	TableType,
	VIPProject,
	VIPProjectRest,
	VipProjectStatus,
	getVipProjectStatusList,
	VIPCompany,
	VIPCertificate,
	IVIPCertificate,
	VipCertificateType,
	getCertificateData,
	VIPCertificateRest,
	VIPCertificateIpRest,
	getVipCertificateTypeLabel,
} from "@/loader/public";
import { VIPProjectRefreshTableMixin } from '@/mixins/VIPProjectMixin';
import CertificatePdfModal from "../certificate/CertificatePdfModal.vue";

@Component({
	components: {
		CertificatePdfModal
	}
})
export default class ProjectsTable extends Mixins(VIPProjectRefreshTableMixin) {
	@Prop({ type: VIPCompany, default: null })
	public company!: VIPCompany | null;

	@Prop({ type: [Number, Array], default: null })
	public status!: VipProjectStatus | VipProjectStatus[] | null;

	@Prop({ type: Boolean, default: false })
	public showCertificates!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideMissingCertificates!: boolean;

	@Prop({ type: Boolean, default: null })
	public missingCertificates!: boolean | null;

	@Prop({ type: Boolean, default: false })
	public hideDate!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideSupervisor!: boolean;

	@Prop({ type: String, default: null })
	public pdfModalId!: string | null;

	public type: TableType = "projects";
	public statuses: VipProjectStatus[] = [VipProjectStatus.bid, VipProjectStatus.signed, VipProjectStatus.ended];
	public name: string = "";
	public certificate: VIPCertificate | null = null;
	public selectedCompany: number | null = null;
	public selectedSupervisor: number | null = null;
	public certificateType = VipCertificateType;

	public get canCreateCertificate(): boolean {
		return auth.user?.capabilities.create_vip_certificate || false;
	}

	public get projectStatuses() {
		return getVipProjectStatusList();
	}

	public get companies(): VIPCompany[] {
		return db.companies.list;
	}

	public get supervisors(): VIPUser[] {
		return db.users.list.filter(u => u.isSupervisor);
	}

	public get fields(): BvTableFieldArray {
		let fields: BvTableFieldArray = [];
		fields.push({
			key: "name",
			label: "Projets",
			sortable: !this.noSorting,
		});
		if (!this.company) {
			fields.push({
				key: "company",
				label: "Clients",
			});
		}
		if (!this.hideSupervisor) {
			fields.push({
				key: "manager",
				label: "Conducteur",
				formatter(value: VIPUser | null) {
					return value?.name || "";
				}
			});
		}
		if (!this.hideDate) {
			fields.push({
				key: "date",
				label: "Date de réponse",
				sortable: !this.noSorting
			});
		}
		if (this.showCertificates) {
			fields.push({
				key: "certificates",
				label: "Certificats",
			});
		}
		return fields;
	}

	public getProjects(context: BvTableCtxObject, callback: Function) {
		VIPProjectRest.list({
			page: context.currentPage,
			per_page: context.perPage,
			orderby: context.sortBy,
			order: context.sortDesc ? "desc" : "asc",
			search: context.filter || undefined,
			fk_company: this.company?.id || this.selectedCompany || undefined,
			fk_manager: this.selectedSupervisor || undefined,
			status: !this.hideFilters ? this.statuses : this.status,
			missingCertificates: this.missingCertificates === null ? undefined : this.missingCertificates,
			options: {
				ips: true,
				manager: !this.hideSupervisor,
				company: {
					contacts: true
				},
				certificates: this.showCertificates ? { data: false } : false,
			}
		}).then(result => {
			this.setResult(callback, result);
		});
		return null;
	}

	public viewProject(project: VIPProject) {
		this.$router.push({ name: "Project", params: { id: project.id } });
	}

	public selectCertificate(value: VIPCertificate | null) {
		this.certificate = value;
		this.$emit("select-certificate", value);
		if (!this.pdfModalId && value) {
			this.$nextTick(() => this.$bvModal.show(this.localPdfModalId));
		}
	}

	public get localPdfModalId() {
		return this.pdfModalId || "projects_certs_pdf_modal";
	}

	public mounted() {
		if (auth.user && auth.user.isSupervisor) {
			this.selectedSupervisor = auth.user.id;
		}
	}

	public createAbilityCertificate(project: VIPProject) {
		this.createCertificate(project, VipCertificateType.abilityCertificate);
	}

	public createWorkCertificate(project: VIPProject) {
		this.createCertificate(project, VipCertificateType.workCertificate);
	}

	public createCertificate(project: VIPProject, type: VipCertificateType) {
		if (project && project.isStatusEnded) {
			busy.start(getVipCertificateTypeLabel(type) + " : création en cours ...");

			let id: number = 0;
			let data: IVIPCertificate = getCertificateData(type, project);

			// @ts-ignore
			VIPCertificateRest.create(data).then(result => {
				if (result.success) {
					id = result.item?.id || 0;
					if (id) {
						return VIPCertificateIpRest.batch(id, project.ips.map(pip => pip.fk_ip));
					}
				}
				return result;
			}).then(result => {
				if (id) {
					this.$router.push({ name: "Certificate", params: { id: id.toString() } });
				}
			}).finally(() => {
				busy.stop();
			});
		}
	}

	@Watch("company")
	public companyChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}

	@Watch("selectedCompany")
	public selectedCompanyChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}

	@Watch("selectedSupervisor")
	public selectedSupervisorChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}

	@Watch("statuses")
	public statusesChanged(newValue: any, oldValue: any) {
		this.filterChanged();
	}
}
